import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"
import PragaSolo from ".."
import TextInput from "components/form/input/TextInput"

export function PragaSoloParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={PragaSolo.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta (%)">
                        <TextInput name="manual.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
